import { ref, onValue, off, query, orderByChild, orderByKey, limitToLast, limitToFirst, startAt, endAt, get } from 'firebase/database';
import { database } from '../firebase';

class DataService {
  constructor() {
    this.listeners = new Map();
  }

  // Tüm teknelerin listesini al
  async getBoatsList() {
    try {
      // Hızlı bağlantı testi kaldırıldı - performance için
      
      const boatsRef = ref(database, 'boats/gateways');
      
      // onValue yerine get kullan - tek seferlik
      let data = null;
      try {
        const snapshot = await get(boatsRef);
        data = snapshot?.val() ?? null;
      } catch (e) {
        console.error('🔥 Firebase get() hatası:', e);
        data = null;
      }
      
      console.log('🔍 Firebase boats/gateways data:', data ? Object.keys(data) : 'YOK');
      
        if (data) {
        const boats = Object.keys(data).map(imei => {
          return {
            imei,
            lastSeen: data[imei]?.gateway_data?.power_status?.last_updated || null,
            battery: data[imei]?.gateway_data?.power_status?.battery_percentage || 'N/A',
            location: data[imei]?.gateway_data?.gnss || null
          };
        });
        console.log('🚢 İşlenmiş boats:', boats.length, 'tekne');
        return boats;
      }

      // Fallback kaldırıldı - get() çalışıyor, Promise race'e gerek yok

      // Son fallback: env veya localStorage default IMEI
      const envImei = (process.env.REACT_APP_DEFAULT_IMEI || '').trim();
      const lsImei = (() => { try { return (localStorage.getItem('defaultImei') || '').trim(); } catch { return ''; }})();
      const fallbackImei = envImei || lsImei;
      if (fallbackImei) {
        return [{ imei: fallbackImei, lastSeen: null, battery: 'N/A', location: null }];
      }

      console.log('❌ boats/gateways altında veri yok');
      return [];
    } catch (error) {
      console.error('Firebase boats list error:', error);
      return [];
    }
  }

  // Belirli bir teknenin realtime verilerini dinle
  listenToBoatData(imei, callback) {
    try {
    const boatRef = ref(database, `boats/gateways/${imei}`);
    
    // Önceki listener'ı temizle
    if (this.listeners.has(imei)) {
      off(ref(database, `boats/gateways/${imei}`));
    }

      // console.log('🔍 Firebase listener başlatılıyor:', `boats/gateways/${imei}`); // Spam azalması için

    const unsubscribe = onValue(boatRef, (snapshot) => {
        try {
      const data = snapshot.val();
          // console.log('🔍 Firebase snapshot:', imei, data ? 'VAR' : 'YOK'); // Spam azalması için
      if (data) {
            // console.log('🔍 Snapshot keys:', Object.keys(data)); // Spam azalması için
        callback(data);
      } else {
            console.log('❌ Firebase snapshot boş:', imei);
            callback(null);
          }
        } catch (error) {
          console.error('❌ Firebase snapshot processing error:', error);
          callback(null);
        }
      }, (error) => {
        console.error('❌ Firebase listener error:', error);
        callback(null);
    });

    this.listeners.set(imei, unsubscribe);
    return unsubscribe;
    } catch (error) {
      console.error('Firebase listener setup error:', error);
      return () => {};
    }
  }

  // Tekne geçmiş verilerini al
  async getBoatHistory(imei, timeRange = '24h') {
    const now = Date.now();
    let startTime;
    
    switch (timeRange) {
      case '1h':
        startTime = now - (60 * 60 * 1000);
        break;
      case '6h':
        startTime = now - (6 * 60 * 60 * 1000);
        break;
      case '24h':
        startTime = now - (24 * 60 * 60 * 1000);
        break;
      case '7d':
        startTime = now - (7 * 24 * 60 * 60 * 1000);
        break;
      case '30d':
        startTime = now - (30 * 24 * 60 * 60 * 1000);
        break;
      default:
        startTime = now - (24 * 60 * 60 * 1000);
    }

    return new Promise((resolve, reject) => {
      const historyRef = ref(database, `boats/gateways/${imei}/history`);
      const historyQuery = query(
        historyRef,
        orderByChild('timestamp'),
        startAt(startTime / 1000),
        endAt(now / 1000)
      );

      onValue(historyQuery, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          // Verileri timestamp'e göre sırala
          const sortedData = Object.entries(data).map(([key, value]) => ({
            id: key,
            ...value
          })).sort((a, b) => a.timestamp - b.timestamp);
          
          resolve(sortedData);
        } else {
          resolve([]);
        }
      }, (error) => {
        reject(error);
      });
    });
  }

  // SAYFALANMIŞ konum verileri al - 10'ar 10'ar
  async getPaginatedLocationData(imei, startTime, endTime, limit = 10, lastTimestamp = null) {
    try {
      console.log('📄 Sayfalı konum verisi:', { imei, limit, lastTimestamp });
      console.log('🔍 Zaman aralığı:', new Date(startTime).toLocaleString('tr-TR'), 'to', new Date(endTime).toLocaleString('tr-TR'));
      
      const gnssRef = ref(database, `boats/gateways/${imei}/history/gnss`);
      
      let historyQuery;
      
      if (lastTimestamp) {
        // lastTimestamp saniye cinsinden, Firebase key'leri milisaniye cinsinden
        const lastTimestampMs = lastTimestamp * 1000; // saniyeyi milisaniyeye çevir
        
        // Sonraki sayfa - lastTimestamp'den ÖNCE olan verileri al (daha eski veriler)
        historyQuery = query(
          gnssRef,
          orderByKey(),
          endAt((lastTimestampMs - 1).toString()), // milisaniye cinsinden sorgu yap
          limitToLast((limit + 1) * 5) // 5x daha fazla al ki zaman filtresi sonrası yeterli kalsın
        );
        
        console.log('🔄 Pagination sorgusu:', {
          lastTimestamp: lastTimestamp,
          lastTimestampMs: lastTimestampMs,
          endAtValue: (lastTimestampMs - 1).toString()
        });
      } else {
        // İlk sayfa - daha fazla kayıt al ki zaman filtresi sonrası istediğimiz kadar kalsın
        historyQuery = query(
          gnssRef,
          limitToLast(limit * 10) // 10x daha fazla al (örn: 10 istiyorsak 100 al)
        );
      }
      
      const snapshot = await get(historyQuery);
      const data = snapshot.val();
      
      console.log('🔥 Firebase ham veri:', data ? `${Object.keys(data).length} timestamp var` : 'VERİ YOK');
      if (data) {
        const timestamps = Object.keys(data).sort((a, b) => parseInt(b) - parseInt(a));
        console.log('🕐 İlk/Son timestamp:', timestamps[0], '→', timestamps[timestamps.length - 1]);
        console.log('🔍 LastTimestamp vs sorgu:', lastTimestamp, 'vs', timestamps[0]);
      } else if (lastTimestamp) {
        console.log('❌ Pagination sorunu - lastTimestamp:', lastTimestamp, 'ama veri yok');
      }
      
      if (!data) return { data: [], hasMore: false };
      
      const entries = Object.entries(data);
      const processedData = entries
        .map(([key, value]) => {
          const keyNum = Number(key);
          const tsMs = isNaN(keyNum) ? null : (keyNum < 1e12 ? keyNum * 1000 : keyNum);
          
          return {
            id: key,
            timestamp: tsMs ? Math.floor(tsMs / 1000) : undefined,
            gateway_data: {
              gnss: {
                latitude: value?.latitude ?? value?.lat,
                longitude: value?.longitude ?? value?.lng ?? value?.lon,
                altitude: value?.altitude ?? value?.alt,
                timestamp: tsMs ? Math.floor(tsMs / 1000) : (value?.timestamp ?? value?.time ?? value?.last_updated)
              }
            }
          };
        })
        .filter((entry) => {
          const gnss = entry.gateway_data?.gnss;
          const lat = gnss?.latitude;
          const lng = gnss?.longitude;
          if (lat == null || lng == null) return false;
          const latN = parseFloat(lat);
          const lngN = parseFloat(lng);
          
          if (isNaN(latN) || isNaN(lngN) || latN === 0 || lngN === 0) return false;
          if (latN < -90 || latN > 90 || lngN < -180 || lngN > 180) return false;
          
          // ✅ ZAMAN FİLTRESİ EKLENDİ - Seçili zaman aralığında olan verileri döndür
          const entryTime = entry.timestamp; // saniye cinsinden
          const startTimeSec = Math.floor(startTime / 1000); // ms'den saniyeye çevir
          const endTimeSec = Math.floor(endTime / 1000); // ms'den saniyeye çevir
          
          if (entryTime && entryTime >= startTimeSec && entryTime <= endTimeSec) {
            return true;
          }
          
          return false; // Zaman aralığı dışında olanları filtrele
        })
        .sort((a, b) => (b.timestamp ?? 0) - (a.timestamp ?? 0));
      
      // Eğer lastTimestamp varsa, ilk elemanı atla (duplicate)
      let resultData = lastTimestamp ? processedData.slice(1) : processedData;
      
      // Sadece istenen kadar kayıt döndür (limit kadar)
      const hasMore = processedData.length > limit; // Eğer işlenmiş veri limiti aşıyorsa daha var demektir
      resultData = resultData.slice(0, limit);
      
      console.log('🎯 HasMore logic:', {
        processedDataLength: processedData.length,
        resultDataLength: resultData.length,
        limit,
        hasMore,
        lastTimestamp: lastTimestamp ? 'var' : 'yok'
      });
      
      console.log('✅ İşlenmiş veri sayısı:', processedData.length, '→', resultData.length, 'döndürülecek');
      
      return {
        data: resultData,
        hasMore,
        lastTimestamp: resultData.length > 0 ? resultData[resultData.length - 1].timestamp : null
      };
      
    } catch (error) {
      console.error('❌ Pagination error:', error);
      return { data: [], hasMore: false };
    }
  }

  // Geçmiş verileri al (Dashboard.js için) - GNSS path formatına uygun
  async getHistoricalData(imei, startTime, endTime) {
    try {
      console.log('🚀 YENI getHistoricalData başlatılıyor:', {
        imei,
        startTime,
        endTime,
        startDate: new Date(startTime).toLocaleString('tr-TR'),
        endDate: new Date(endTime).toLocaleString('tr-TR')
      });
      
      // Beklenen yol: boats/gateways/{imei}/history/gnss/{timestamp}/{latitude|longitude|...}
      const gnssRef = ref(database, `boats/gateways/${imei}/history/gnss`);

      // DAHA FAZLA VERİ - seçili zaman aralığını kapsamak için
      const historyQuery = query(
        gnssRef,
        limitToLast(500)  // 50'den 500'e çıkarıldı - daha kapsamlı
      );
      
      console.log('🔍 Firebase GNSS sorgusu başlatılıyor...');

      const snapshot = await get(historyQuery);
        const data = snapshot.val();
      if (data && typeof data === 'object') {
          const entries = Object.entries(data);
          const rows = entries
            .map(([key, value]) => {
              // key genelde timestamp (ms veya s). Güvenli şekilde ms'e çevir
              const keyNum = Number(key);
              const tsMs = isNaN(keyNum)
                ? null
                : (keyNum < 1e12 ? keyNum * 1000 : keyNum);

                    // Debug kaldırıldı - performance için

              return {
              id: key,
                timestamp: tsMs ? Math.floor(tsMs / 1000) : undefined, // saniye olarak da sağla
                gateway_data: {
                  gnss: {
                    latitude: value?.latitude ?? value?.lat,
                    longitude: value?.longitude ?? value?.lng ?? value?.lon,
                    altitude: value?.altitude ?? value?.alt,
                    timestamp: tsMs ? Math.floor(tsMs / 1000) : (value?.timestamp ?? value?.time ?? value?.last_updated)
                  }
                }
              };
            })
            .filter((entry) => {
              const gnss = entry.gateway_data?.gnss;
              const lat = gnss?.latitude;
              const lng = gnss?.longitude;
              if (lat == null || lng == null) return false;
              const latN = parseFloat(lat);
              const lngN = parseFloat(lng);

              // Koordinat validasyonu
              if (isNaN(latN) || isNaN(lngN) || latN === 0 || lngN === 0) return false;
              if (latN < -90 || latN > 90 || lngN < -180 || lngN > 180) return false;

              // ZamanARALIĞI KONTROLÜNÜ KALDIR - TÜM VERİLERİ DÖN
              // Tarih filtresini frontend'de yapalım
              return true;
            })
            .sort((a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0));
            // slice kaldırıldı - tüm verileri döndür

          if (rows.length > 0) {
            return rows;
          }

          // Fallback: zaman filtresi olmadan son 20 geçerli noktayı döndür
          const fallback = entries
            .map(([key, value]) => {
              const keyNum = Number(key);
              const tsMs = isNaN(keyNum) ? null : (keyNum < 1e12 ? keyNum * 1000 : keyNum);
              return {
                id: key,
                timestamp: tsMs ? Math.floor(tsMs / 1000) : undefined,
                gateway_data: {
                  gnss: {
                    latitude: value?.latitude ?? value?.lat,
                    longitude: value?.longitude ?? value?.lng ?? value?.lon,
                    altitude: value?.altitude ?? value?.alt,
                    timestamp: tsMs ? Math.floor(tsMs / 1000) : (value?.timestamp ?? value?.time ?? value?.last_updated)
                  }
                }
              };
            })
            .filter((entry) => {
              const gnss = entry.gateway_data?.gnss;
              const latN = parseFloat(gnss?.latitude);
              const lngN = parseFloat(gnss?.longitude);
              return (
                !isNaN(latN) && !isNaN(lngN) && latN !== 0 && lngN !== 0 &&
                latN >= -90 && latN <= 90 && lngN >= -180 && lngN <= 180
              );
            })
            .sort((a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0))
            .slice(-20);

          return fallback;
        } else {
          return [];
        }
    } catch (error) {
      console.error('Firebase history query error:', error);
      return [];
    }
  }

  // Firebase'de veri var mı kontrol et
  async checkDataExists(imei) {
    return new Promise((resolve, reject) => {
      const historyRef = ref(database, `boats/gateways/${imei}/history/gnss`);
      const historyQuery = query(historyRef, limitToFirst(1));
      
      onValue(historyQuery, (snapshot) => {
        const data = snapshot.val();
        console.log('Data existence check for', imei, ':', data ? 'EXISTS' : 'NO DATA');
        resolve(!!data);
      }, (error) => {
        console.error('Data existence check error:', error);
        reject(error);
      });
    });
  }



  // Sensör geçmiş verilerini al
  async getSensorHistory(imei, sensorMac, sensorType, timeRange = '24h') {
    const now = Date.now();
    let startTime;
    
    switch (timeRange) {
      case '1h':
        startTime = now - (60 * 60 * 1000);
        break;
      case '6h':
        startTime = now - (6 * 60 * 60 * 1000);
        break;
      case '24h':
        startTime = now - (24 * 60 * 60 * 1000);
        break;
      case '7d':
        startTime = now - (7 * 24 * 60 * 60 * 1000);
        break;
      case '30d':
        startTime = now - (30 * 24 * 60 * 60 * 1000);
        break;
      default:
        startTime = now - (24 * 60 * 60 * 1000);
    }

    return new Promise((resolve, reject) => {
      const sensorHistoryRef = ref(database, `boats/gateways/${imei}/sensors/${sensorMac}/history/${sensorType}`);
      const historyQuery = query(
        sensorHistoryRef,
        orderByChild('timestamp'),
        startAt(startTime / 1000),
        endAt(now / 1000)
      );

      onValue(historyQuery, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const sortedData = Object.entries(data).map(([key, value]) => ({
            id: key,
            ...value
          })).sort((a, b) => a.timestamp - b.timestamp);
          
          resolve(sortedData);
        } else {
          resolve([]);
        }
      }, (error) => {
        reject(error);
      });
    });
  }

  // Tüm listener'ları temizle
  cleanup() {
    this.listeners.forEach((unsubscribe) => {
      unsubscribe();
    });
    this.listeners.clear();
  }

  // Tek bir listener'ı temizle
  stopListening(imei) {
    try {
    if (this.listeners.has(imei)) {
        const unsubscribe = this.listeners.get(imei);
        if (typeof unsubscribe === 'function') {
          unsubscribe();
        }
      this.listeners.delete(imei);
        console.log('🛑 Firebase listener stopped:', imei);
      }
    } catch (error) {
      console.error('Error stopping listener:', error);
    }
  }
}

const dataService = new DataService();
export default dataService;
